app.service('deliveryTime',function(orderConfig, paymentBox, validate) {
	var $self;
	var config;

	function setElemnts() {
		
	}

	function setEvents() {
	
	}

	function init() {
		setElemnts();
		setEvents();
        if($('#payment-content').length){
            paymentBox.init();
        }
	}

	return {
		init
	};
});
